<template>
  <form ref="form" @submit.prevent="sendEmail">
    <label>Name</label>
    <input type="text" name="user_name">
    <label>Email</label>
    <input type="email" name="user_email">
    <label>Message</label>
    <textarea name="message"></textarea>
    <input type="submit" value="Send">
  </form>
</template>

<script>
// import emailjs from 'emailjs-com';

export default {
  methods: {
     sendEmail() {
    //   // emailjs.sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', this.$refs.form, 'YOUR_USER_ID');
    //     .then((result) => {
    //         console.log('SUCCESS!', result.text);
    //     }, (error) => {
    //         console.log('FAILED...', error.text);
    //     });
     }
  }
}
</script>
